import { render, staticRenderFns } from "./DataListing.vue?vue&type=template&id=647eb9bd&scoped=true&"
import script from "./DataListing.vue?vue&type=script&lang=js&"
export * from "./DataListing.vue?vue&type=script&lang=js&"
import style0 from "./DataListing.vue?vue&type=style&index=0&id=647eb9bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647eb9bd",
  null
  
)

export default component.exports